import { render, staticRenderFns } from "./personalCenterWX.vue?vue&type=template&id=60332b10&scoped=true"
import script from "./personalCenterWX.vue?vue&type=script&lang=js"
export * from "./personalCenterWX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60332b10",
  null
  
)

export default component.exports